document.addEventListener('DOMContentLoaded', function () {
  var cartLinks = document.querySelectorAll('a.cart-link');

  if (!cartLinks.length) return;

  cartLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // oprește drawer-ul
      window.location.href = link.getAttribute('href') || '/cart'; // mergi pe /cart
    });
  });
});
